import { IMessageAttachment } from '@entities/message/model/types';
import { IPreviewFile } from '@shared/ui/Lightbox/model/types';

export const mapAttachmentsToLightboxFiles = (attachments: IMessageAttachment[]): IPreviewFile[] =>
    attachments.map((attachment) => ({
        id: attachment.id,
        fileSrc: attachment.originalUrl,
        mimeType: attachment.mimeType,
        fileName: attachment.name,
    }));
